import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  IconButton
} from "@mui/material";
import {
  ArrowBackIos as ArrowBackIosIcon,
  PersonOff as PersonOffIcon,
  PersonAddDisabled as PersonAddDisabledIcon,
  CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";

const BulkUploadSummary = ({ data }) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  console.log("📦 Received Summary Data", data);

  const usersAdded = data?.usersAdded ?? 0;
  const successUsers = data?.successes || [];
  const failureUsers = data?.failures || [];

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      <Box sx={{ padding: "30px", width: "100%" }}>
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ mr: 1 }}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography variant="h5" fontWeight={600}>
            Bulk Upload Summary
          </Typography>
        </Box>

        {/* Total Users Added */}
        <Typography variant="h6" gutterBottom>
          Total Users Added: {usersAdded}
        </Typography>

        {/* Success Users Table */}
        {successUsers.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#f0fdf4",
              border: "1px solid #bbf7d0",
              padding: "20px",
              borderRadius: "16px",
              mb: 4,
              boxShadow: "0 0 8px rgba(16, 185, 129, 0.3)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 28 }} />
              <Typography variant="subtitle1" fontWeight={500}>
                Successfully Added Users:
              </Typography>
            </Box>

            <Paper variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#ecfdf5" }}>
                    <TableCell>S.No</TableCell>
                    <TableCell>Employee ID</TableCell>
                    <TableCell>Employee Name</TableCell>
                    <TableCell>Employee Email</TableCell>
                    <TableCell>Department</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {successUsers && successUsers.map((user, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{user?.employeeId || "-"}</TableCell>
                      <TableCell>{user?.employeeName || "-"}</TableCell>
                      <TableCell>{user?.employeeEmail || "-"}</TableCell>
                      <TableCell>{user?.businessName || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>

              </Table>
            </Paper>
          </Box>
        )}
        {successUsers.length === 0 && failureUsers.length === 0 && (
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            No users were added or failed. Please verify your upload file.
          </Typography>
        )}


        {/* Failure Users Table */}
        {failureUsers.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#fff1f2",
              border: "1px solid #fecdd3",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 0 8px rgba(244, 63, 94, 0.3)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <PersonAddDisabledIcon sx={{ color: "#e11d48", fontSize: 28 }} />
              <Typography variant="subtitle1" fontWeight={500}>
                User(s) could not be added due to the following reasons:
              </Typography>
            </Box>

            <Paper variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#fef2f2", textAlign: "left" }}>
                    <TableCell>S.No</TableCell>

                    <TableCell>Failure Reason</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {failureUsers.map((user, index) => (
                    <TableRow key={index} sx={{ textAlign: "left" }}>
                      <TableCell sx={{ textAlign: "left" }}>{index + 1}</TableCell>

                      <TableCell sx={{ textAlign: "left" }}>{user.reason || "Unknown Error"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Box>
        )}


        <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            color="inherit"
            sx={{ borderRadius: "10px", px: 4, py: 1.2 }}
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default BulkUploadSummary;
